var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "101px",
    viewBox: "0 0 90 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Water Header") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2.70015113e-21 0.0351766598 2.70015113e-21 69.5146571 44.5489875 69.5146571 44.5489875 0.0351766598"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Water-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(44.260028, 23.791822)",
    fill: "#A0C0E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3634623,67.6954257 L27.4021406,67.7038046 C37.6612249,61.2949362 43.3054866,53.0261493 44.335124,42.896646 C44.4955895,41.319017 44.5068955,39.6186968 44.3811413,37.8691007 C44.0564415,33.3500754 42.786205,28.4917043 40.578564,24.487184 C36.8170452,17.662961 31.5371534,12.5773619 30.8135708,11.9058521 C23.511694,5.1340971 20.2539855,2.58271911 18.2032398,0.110142763 L0.118831781,0.110142763 L0.118831781,37.8691007 L0.118831781,76.2062034 C0.157708478,76.2062034 0.196188474,76.2081984 0.235065171,76.2081984 C10.5461173,76.2081984 20.0004936,73.0120433 27.3634623,67.6954257",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.817414,19.6141391 C58.7852633,17.320994 58.4427328,15.3078878 58.2036751,13.071996 C58.1735451,12.790149 58.1448027,12.5052888 58.1168531,12.2152054 C58.0365725,11.3827224 58.0647203,10.4053987 58.192971,9.2936803 L44.2600277,9.2936803 L44.2600277,13.071996 L44.2600277,23.7918216 L62.3328723,23.7918216 C61.3120204,22.5515344 60.5898916,21.3307335 59.817414,19.6141391",
    id: "Fill-4",
    fill: "#B2CFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5777412,6.67370099 C58.9889961,4.74952012 59.6239437,2.52753752 60.4887045,0 C53.7001351,2.63210608 48.2967624,4.85488388 44.2602251,6.67370099 L44.2600277,6.67370099 L44.2600277,9.2936803 L58.1374634,9.2936803 C58.2306522,8.4917229 58.3753713,7.62117966 58.5777412,6.67370099",
    id: "Fill-6",
    fill: "#CBE2F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 30.111524)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0382568,0.0351766598 C9.33482365,2.88556172 6.77842669,6.09408741 5.07416206,9.53924884 C4.08694774,11.5349168 -0.199614536,17.5719168 0.00719241915,28.3127493 C0.121155404,34.2374071 1.6823686,40.00132 4.69123049,45.6050854 C10.7800815,59.5498623 26.3222817,69.47223 44.5489875,69.5146571 L44.5489875,0.0351766598 L12.0382568,0.0351766598 Z",
    id: "Fill-8",
    fill: "#5086C5",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.6288612,30.1115242 L44.6288612,25.9930501 L44.6288612,6.69144981 C42.5476777,7.62091553 40.820353,8.44695287 39.4653857,9.16380479 C30.0420777,14.1492111 23.5799262,19.6438186 19.1205881,23.5582152 C18.2611028,24.3127857 17.3419449,25.1267134 16.3955365,25.9930501 C15.0135176,27.2582113 13.5728206,28.6367269 12.1715076,30.1115242 L44.6288612,30.1115242 Z",
    id: "Fill-11",
    fill: "#7FA3D3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBanner);
export default __webpack_public_path__ + "static/media/WaterBanner.af8e847b90930e81271a4838ab054e38.svg";
export { ForwardRef as ReactComponent };